module.exports = __webpack_public_path__ + "img/staysure-logo.116779fe.png";